import type { HTMLAttributes } from 'react'

import clsx from 'clsx'

export type SkeletonVariant = 'default' | 'pill' | 'circle' | 'card' | 'thumb'

const variantClassName: Record<SkeletonVariant, string> = {
  default: 'rounded-md',
  pill: 'rounded-full',
  circle: 'rounded-full',
  card: 'rounded-[var(--radius-card-gamification,1rem)]',
  thumb: 'rounded-[0.625rem]'
}

export type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  variant?: SkeletonVariant
}

/**
 * Bloco base de carregamento — shimmer sutil com fallback estático em
 * `prefers-reduced-motion`. Usar para compor skeletons de página, não
 * diretamente em features (preferir os patterns em `PageListScreenSkeleton`,
 * `ResourceListCardSkeleton`, etc.).
 */
export const Skeleton = ({
  className,
  variant = 'default',
  ...props
}: SkeletonProps) => (
  <div
    role="presentation"
    aria-hidden
    className={clsx('skeleton-block skeleton-shimmer', variantClassName[variant], className)}
    {...props}
  />
)
